import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=54a8458a&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=54a8458a&prod&lang=less"
import style1 from "./ForgetPassword.vue?vue&type=style&index=1&id=54a8458a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8458a",
  null
  
)

export default component.exports